<template>
    <div class="content_div">
        <el-card>
            <el-form :inline="true" :model="query">
                <el-form-item label="题目">
                    <el-select v-model="query.questionId" placeholder="全部" clearable filterable style="width:200px">
                        <el-option v-for="q in questionList" :key="q.id" :label="q.title" :value="q.id"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="级别">
                    <el-select v-model="query.essayLevel" placeholder="全部" clearable style="width:100px">
                        <el-option label="低阶" value="A"/>
                        <el-option label="中阶" value="B"/>
                        <el-option label="高阶" value="C"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="query.status" placeholder="请选择" clearable style="width:120px">
                        <el-option label="生成中" :value="0"/>
                        <el-option label="已生成" :value="1"/>
                        <el-option label="失败" :value="2"/>
                    </el-select>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
                <el-button icon="el-icon-refresh" @click="load">刷新</el-button>
            </el-form>

            <el-table :data="list" border @row-click="handlePreview" style="cursor:pointer">
                <el-table-column type="index" label="序号" width="60"/>
                <el-table-column label="题目" min-width="250" show-overflow-tooltip>
                    <template slot-scope="s">
                        <span v-if="questionMap[s.row.questionId]">{{ questionMap[s.row.questionId].title }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="级别" width="80">
                    <template slot-scope="s">{{ {A:'低阶',B:'中阶',C:'高阶'}[s.row.essayLevel] || s.row.essayLevel }}</template>
                </el-table-column>
                <el-table-column prop="actualWordCount" label="词数" width="70"/>
                <el-table-column label="状态" width="100">
                    <template slot-scope="s"><el-tag :type="['','success','danger'][s.row.status]||'info'">{{ ['生成中','已生成','失败'][s.row.status]||'未知' }}</el-tag></template>
                </el-table-column>
                <el-table-column prop="createTime" label="生成时间" width="180"/>
                <el-table-column label="操作" width="180" fixed="right">
                    <template slot-scope="s">
                        <el-button type="text" icon="el-icon-view" @click.stop="handlePreview(s.row)">预览</el-button>
                        <el-button type="text" icon="el-icon-download" :disabled="s.row.status!==1" @click.stop="handleDownload(s.row)">下载</el-button>
                        <el-button type="text" icon="el-icon-delete" @click.stop="btnDel(s.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination style="margin-top:10px" background layout="total,prev,pager,next"
                :current-page="query.currentPage" :page-size="query.pageSize" :total="total" @current-change="p=>{query.currentPage=p;load()}"/>
        </el-card>

        <el-dialog :close-on-click-modal="false" title="训练预览" :visible.sync="previewVisible" width="80%" top="5vh">
            <div v-if="previewData" style="max-height:70vh;overflow-y:auto;padding:0 20px">
                <div style="text-align:center;margin-bottom:16px">
                    <h2>{{ previewData.title }}</h2>
                    <p style="color:#999;font-size:13px">级别：{{ previewData.levelName }}</p>
                </div>
                <el-tabs v-model="activeModule">
                    <el-tab-pane label="范文挖空" name="gapFill">
                        <el-tabs v-model="activeGapFillTab" type="border-card">
                            <el-tab-pane label="初级" name="low">
                                <template v-if="gapFillList('low').length > 0">
                                    <div v-for="item in gapFillList('low')" :key="item.sentenceNo" style="margin-bottom:14px">
                                        <div style="display:flex;align-items:baseline;gap:8px">
                                            <span style="color:#909399;font-size:12px;min-width:30px">{{ item.sentenceNo }}.</span>
                                            <span style="white-space:pre-wrap;line-height:1.8">{{ item.gappedSentence }}</span>
                                        </div>
                                        <div style="margin-left:38px;margin-top:4px">
                                            <el-tag v-for="(ans,i) in item.answers" :key="i" size="small" type="success" style="margin-right:6px;margin-bottom:4px">{{ ans }}</el-tag>
                                        </div>
                                    </div>
                                </template>
                                <el-empty v-else description="暂无数据" :image-size="50"/>
                            </el-tab-pane>
                            <el-tab-pane label="中级" name="medium">
                                <template v-if="gapFillList('medium').length > 0">
                                    <div v-for="item in gapFillList('medium')" :key="item.sentenceNo" style="margin-bottom:14px">
                                        <div style="display:flex;align-items:baseline;gap:8px">
                                            <span style="color:#909399;font-size:12px;min-width:30px">{{ item.sentenceNo }}.</span>
                                            <span style="white-space:pre-wrap;line-height:1.8">{{ item.gappedSentence }}</span>
                                        </div>
                                        <div style="margin-left:38px;margin-top:4px">
                                            <el-tag v-for="(ans,i) in item.answers" :key="i" size="small" type="warning" style="margin-right:6px;margin-bottom:4px">{{ ans }}</el-tag>
                                        </div>
                                    </div>
                                </template>
                                <el-empty v-else description="暂无数据" :image-size="50"/>
                            </el-tab-pane>
                            <el-tab-pane label="高级" name="high">
                                <template v-if="gapFillList('high').length > 0">
                                    <div v-for="item in gapFillList('high')" :key="item.sentenceNo" style="margin-bottom:14px">
                                        <div style="display:flex;align-items:baseline;gap:8px">
                                            <span style="color:#909399;font-size:12px;min-width:30px">{{ item.sentenceNo }}.</span>
                                            <span style="white-space:pre-wrap;line-height:1.8">{{ item.gappedSentence }}</span>
                                        </div>
                                        <div style="margin-left:38px;margin-top:4px">
                                            <el-tag v-for="(ans,i) in item.answers" :key="i" size="small" type="danger" style="margin-right:6px;margin-bottom:4px">{{ ans }}</el-tag>
                                        </div>
                                    </div>
                                </template>
                                <el-empty v-else description="暂无数据" :image-size="50"/>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane label="固定搭配" name="collocations">
                        <el-table :data="previewData.collocationExercises" border size="small" v-if="previewData.collocationExercises && previewData.collocationExercises.length > 0">
                            <el-table-column type="index" label="#" width="40"/>
                            <el-table-column prop="english" label="英文" min-width="200"/>
                            <el-table-column prop="chinese" label="中文" min-width="200"/>
                        </el-table>
                        <el-empty v-else description="暂无数据" :image-size="50"/>
                    </el-tab-pane>
                    <el-tab-pane label="好词" name="words">
                        <el-table :data="previewData.goodWordExercises" border size="small" v-if="previewData.goodWordExercises && previewData.goodWordExercises.length > 0">
                            <el-table-column type="index" label="#" width="40"/>
                            <el-table-column prop="english" label="英文" min-width="160"/>
                            <el-table-column prop="chinese" label="中文" min-width="160"/>
                            <el-table-column prop="partOfSpeech" label="词性" width="80"/>
                        </el-table>
                        <el-empty v-else description="暂无数据" :image-size="50"/>
                    </el-tab-pane>
                    <el-tab-pane label="好句" name="sentences">
                        <el-table :data="previewData.goodSentenceExercises" border size="small" v-if="previewData.goodSentenceExercises && previewData.goodSentenceExercises.length > 0">
                            <el-table-column type="index" label="#" width="40"/>
                            <el-table-column prop="english" label="英文" min-width="300"/>
                            <el-table-column prop="chinese" label="中文" min-width="300"/>
                        </el-table>
                        <el-empty v-else description="暂无数据" :image-size="50"/>
                    </el-tab-pane>
                    <el-tab-pane label="逐句翻译" name="translation">
                        <el-table :data="previewData.translationExercises" border size="small">
                            <el-table-column type="index" label="序号" width="60"/>
                            <el-table-column prop="chinese" label="汉语" min-width="250"/>
                            <el-table-column prop="englishReference" label="参考英语" min-width="250"/>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="汉语草稿" name="chineseDraft">
                        <h4 style="margin-bottom:8px">参考范文</h4>
                        <div style="white-space:pre-wrap;line-height:1.8;background:#f5f7fa;padding:15px;border-radius:4px">{{ previewData.modelEssay }}</div>
                        <el-divider/>
                        <h4 style="margin-bottom:8px">全文翻译</h4>
                        <div style="white-space:pre-wrap;line-height:1.8;background:#f0f9eb;padding:15px;border-radius:4px">{{ previewData.fullTranslation }}</div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div slot="footer" v-if="previewData">
                <el-button type="primary" icon="el-icon-download" @click="handleDownloadInDialog(previewData.instanceId)">下载Word</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { reqInstancePage, reqInstanceDelete, previewEssay, downloadEssay, reqQuestionPage } from '@/api/education/essay'

export default {
    name: 'EssayRecord',
    data() {
        return {
            list: [], total: 0, questionList: [], questionMap: {},
            query: { currentPage: 1, pageSize: 10, questionId: null, essayLevel: null, status: null },
            previewVisible: false, previewData: null, activeModule: 'gapFill', activeGapFillTab: 'low'
        }
    },
    created() { this.loadQuestions(); this.load() },
    methods: {
        gapFillList(level) {
            return this.previewData?.gapFillLevels?.[level] || []
        },
        loadQuestions() {
            reqQuestionPage({ currentPage: 1, pageSize: 999 }).then(r => {
                this.questionList = r.records || []
                const map = {}
                this.questionList.forEach(q => { map[q.id] = q })
                this.questionMap = map
            })
        },
        load() { reqInstancePage(this.query).then(r => { this.list = r.records || []; this.total = r.total || 0 }) },
        handlePreview(row) {
            previewEssay(row.id).then(r => { this.previewData = r; this.activeModule = 'gapFill'; this.activeGapFillTab = r.level || 'low'; this.previewVisible = true })
        },
        async handleDownload(row) {
            try {
                const r = await downloadEssay(row.id)
                if (r) window.open(r, '_blank')
                else this.$message.warning('下载链接为空')
            } catch (e) { this.$message.error('下载失败') }
        },
        async handleDownloadInDialog(id) {
            try {
                const r = await downloadEssay(id)
                if (r) window.open(r, '_blank')
                else this.$message.warning('下载链接为空')
            } catch (e) { this.$message.error('下载失败') }
        },
        btnDel(id) { this.$confirm('确认删除？').then(() => { reqInstanceDelete(id).then(() => { this.$message.success('已删除'); this.load() }) }) }
    }
}
</script>
